import { type FunctionComponent } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import { SharedFAQAuthor } from './SharedFAQAuthor.tsx';

import { type SharedFAQAnswer_answer$data } from './__generated__/SharedFAQAnswer_answer.graphql.ts';
import dibsCss from 'dibs-css';
import classnames from 'classnames';
import styles from './SharedFAQAnswer.module.css';

type Props = {
    answer: SharedFAQAnswer_answer$data;
};

const SharedFAQAnswerComponent: FunctionComponent<Props> = ({ answer }) => {
    const { serviceId, text, author, formattedCreatedDate } = answer;

    if (text) {
        return (
            <div
                key={serviceId}
                className={classnames(
                    styles.answer,
                    dibsCss.selfCenter,
                    dibsCss.bgAlabaster,
                    dibsCss.sassyFontBody,
                    dibsCss.pSmall,
                    dibsCss.mbMedium
                )}
            >
                <SharedFAQAuthor author={author} formattedCreatedDate={formattedCreatedDate} />
                <div
                    data-tn="faq-answer-text"
                    dangerouslySetInnerHTML={{
                        __html: text,
                    }}
                />
            </div>
        );
    }
    return null;
};

export const SharedFAQAnswer = createFragmentContainer(SharedFAQAnswerComponent, {
    answer: graphql`
        fragment SharedFAQAnswer_answer on AnswerType {
            serviceId
            text
            formattedCreatedDate
            author {
                ...SharedFAQAuthor_author
            }
        }
    `,
});
